const state = () => ({
  userInfo: {
    id: 2,
    
  },
})
export default state
